<template>
  <v-main></v-main>
</template>

<script>
import axios from "axios";
export default {
  created() {
    if (this.$store.getters.loggedIn) {
      axios
        .post(
          this.$store.getters.getAPI + "/admin/logout",
          null,
          this.$store.getters.getAuthHeader
        )
        .then((response) => {
          localStorage.removeItem("token");
          localStorage.removeItem("name");
          this.$store.commit("destroyToken");
          if (response.status == 200) {
            this.$router.push({
              name: "Login",
            });
            this.$store.dispatch('PushSuccessMsg', response.data.message);
          } else {
            this.$router.push({
              name: "Login",
            });
            this.$store.dispatch('PushErrorMsg', 'Something went wrong');
          }
        })
        .catch((error) => {
          if (error){
            localStorage.removeItem("token");
            localStorage.removeItem("name");
            this.$store.commit("destroyToken");
            this.$store.dispatch('PushErrorMsg', 'Something went wrong');
          }
        });
    }
  },
};
</script>
